import { BaseModel } from "../../abstracts/base.model"

export class ReportCommentModel extends BaseModel {
    ReportCommentID: string
    TrainingID: string
    ClassID: string
    ParticipantID: string
    Template: string
}